/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

jQuery( document ).ready(function($) {

    $(document).on('click','.qtybox .btnqty', function(){
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
   		  
          if($(this).hasClass('qtyplus')) {
            qty++;
          }else {
            if(qty > 1) {
              qty--;
            }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
        }); 
});
$(document).ready(function() {
  		$('#quick-view .qv-product-options>div label:first').removeClass('swatch_color_cm');
      $(document).on('click','#quick-view .qv-product-options>div label', function(){
        $('#quick-view .qv-product-options>div label').removeClass('swatch_color_cm');
      	$(this).addClass("swatch_color_cm");

      });
});


 